var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('div',{ref:"toolbarRef",staticClass:"toolbar",staticStyle:{"display":"none"}}),_c('div',{ref:"textRef",staticClass:"text"})])}
var staticRenderFns = []

export { render, staticRenderFns }